import React from 'react';

import classNames from 'classnames';

export const IndexIcon = ({
  index, className, ...rest
}) => (
  <div className={classNames('text-center text-lg text-white bg-brand rounded-full', className)} {...rest}>
    {index}
  </div>
)

export default IndexIcon;
